import React from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Tooltip, Typography
} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Copy01Icon} from "@hugeicons/core-free-icons";
import {toast} from "react-toastify";

export const ApiKeyCreatedDialog = ({apiKey, handleClose}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(apiKey.key);
      toast.success("API key copied to clipboard");
    } catch (e) {
      console.error(e);
      toast.error("Failed to copy API key");
    }
  };

  return (
    <Dialog
      open={Boolean(apiKey)}
      onClose={handleClose}
      PaperProps={{sx: {minWidth: "360px", maxWidth: "sm", borderRadius: 4, p: 2, width: "100%"}}}
    >
      <DialogTitle>API Key Created</DialogTitle>
      <DialogContent sx={{display: "flex", flexDirection: "column", gap: 2}}>
        <Typography variant={"body2"} color={"text.secondary"}>
          Copy your key and store it somewhere safe. Treat it like a password.
        </Typography>
        <Stack
          direction={"row"} alignItems={"center"} gap={1}
          sx={{p: 1.5, borderRadius: 2, bgcolor: "grey.100", border: 1, borderColor: "divider"}}
        >
          <Typography
            variant={"body2"} fontFamily={"monospace"} fontSize={13}
            sx={{flex: 1, wordBreak: "break-all", userSelect: "all"}}
          >
            {apiKey?.key}
          </Typography>
          <Tooltip title={"Copy"}>
            <IconButton sx={{borderRadius: "50% !important"}} onClick={handleCopy}>
              <HugeiconsIcon icon={Copy01Icon} size={18}/>
            </IconButton>
          </Tooltip>
        </Stack>
      </DialogContent>
      <DialogActions sx={{px: 2, py: 1}}>
        <Button variant={"modal"} onClick={handleClose}>Done</Button>
      </DialogActions>
    </Dialog>
  );
};
